import React, { useState } from "react";
import CallsSidebar from "./CallsSidebar";
import CallsRightSection from "./CallsRightSection";
import "./index.scss";

const CallsLayout = () => {
  const [selectedNumberToCall, setSelectedNumberToCall] = useState<any>(null);

  return (
    <div className="calls-layout-container">
      <CallsSidebar onCallClick={setSelectedNumberToCall} />
      <CallsRightSection selectedNumberToCall={selectedNumberToCall} />
    </div>
  );
};

export default CallsLayout;
